var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"other-info"},[_c('detail-amenities',{attrs:{"amenities":_vm.hotel.originalAmeneties}}),_c('div',{staticClass:"terms-know"},[_c('detail-terms')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }